/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentDiscountTypeViewModel } from "../types/IndividualPaymentDiscountTypeViewModel.ts";

export const individualPaymentDiscountTypeViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  description: z.string().nullish(),
  mustSelectAssociatedCompany: z.optional(z.boolean()),
}) as unknown as ToZod<IndividualPaymentDiscountTypeViewModel>;
